module.exports = __webpack_public_path__ + "static/media/default_avatar.cdfb6cf0.jpg";